import React from "react";

const ApplePay = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={17}
      viewBox="0 0 40 17"
      {...props}
    >
      <title>{"ApplePay"}</title>
      <path d="M7.417 2.453A2.951 2.951 0 008.1.351a2.921 2.921 0 00-1.937 1 2.76 2.76 0 00-.7 2.02 2.437 2.437 0 001.954-.921m.669 1.066c-1.079-.064-2 .613-2.511.613s-1.305-.58-2.158-.565A3.185 3.185 0 00.711 5.211c-1.159 2-.3 4.965.822 6.593.547.8 1.207 1.692 2.077 1.66.821-.032 1.143-.532 2.142-.532s1.288.532 2.157.516c.9-.016 1.466-.806 2.013-1.612a7.176 7.176 0 00.9-1.853 2.93 2.93 0 01-1.755-2.66 2.984 2.984 0 011.417-2.5 3.089 3.089 0 00-2.4-1.3m10.761-2.25a3.793 3.793 0 013.978 3.972 3.835 3.835 0 01-4.037 3.988h-2.6v4.131h-1.873V1.273zm-2.656 6.385h2.153a2.264 2.264 0 002.563-2.405 2.255 2.255 0 00-2.555-2.4h-2.161zm7.1 3.2c0-1.55 1.181-2.438 3.359-2.572l2.337-.143v-.67c0-.981-.645-1.517-1.793-1.517a1.646 1.646 0 00-1.775 1.232h-1.693c.05-1.567 1.524-2.707 3.518-2.707 2.144 0 3.543 1.123 3.543 2.866v6.016h-1.734v-1.448h-.042a3.091 3.091 0 01-2.764 1.541 2.656 2.656 0 01-2.957-2.597zm5.7-.779V9.4l-2.089.135c-1.172.075-1.784.511-1.784 1.274 0 .737.637 1.215 1.633 1.215a2.046 2.046 0 002.235-1.944zm3.39 6.521v-1.45a5.376 5.376 0 00.552.033 1.493 1.493 0 001.583-1.256l.168-.537-3.175-8.8h1.96l2.212 7.139h.041l2.212-7.139h1.909l-3.291 9.243c-.754 2.12-1.617 2.816-3.443 2.816a5.212 5.212 0 01-.728-.049z" />
    </svg>
  );
};

export default ApplePay;
